import 'shepherd.js/dist/css/shepherd.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import router from './router';

import './styles/index.css';
import vuetify from './plugins/vuetify';
import VueShepherdPlugin from 'vue-shepherd';
import * as Sentry from "@sentry/vue";

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(vuetify);
app.use(VueShepherdPlugin);

Sentry.init({
    dsn: "https://f7b389e56a2bbcfa523d3963f79797e3@sentry.writewise.io/2",
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
      }),
      new Sentry.Replay({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });

  
// app.mount('#app');
router.isReady().then(() => app.mount('#app'))

